// extracted by mini-css-extract-plugin
module.exports = {"driverImage":"AboutDriver_driverImage__2sZNm"};